import { matchPath } from 'react-router-dom';
import type { ImgCloudPageKey } from './pageKeys';

export interface ImgCloudRouteMetadata {
  path: string;
  pageKey: ImgCloudPageKey | null;
}

export const IMG_CLOUD_ROUTE_METADATA: readonly ImgCloudRouteMetadata[] = [
  { path: '/', pageKey: 'home' },
  { path: '/index.html', pageKey: 'home' },
  { path: '/img-cloud/index.html', pageKey: 'home' },
  { path: '/web-hosting', pageKey: 'web-hosting' },
  { path: '/web-hosting/ai-preview', pageKey: 'web-hosting-ai-preview' },
  { path: '/web-hosting/editor/:id', pageKey: 'web-hosting-editor' },
  { path: '/galleries', pageKey: 'galleries' },
  { path: '/directories', pageKey: 'directories' },
  { path: '/endpoint-list', pageKey: 'endpoint-list' },
  { path: '/international', pageKey: 'international' },
  { path: '/image-categories', pageKey: 'image-categories' },
  { path: '/monitor', pageKey: 'monitor' },
  { path: '/about', pageKey: 'about' },
  { path: '/ai-info', pageKey: 'ai-info' },
  { path: '/faq', pageKey: 'faq' },
  { path: '/demo', pageKey: 'demo' },
  { path: '/image-processing', pageKey: 'image-processing' },
  { path: '/image-watermark', pageKey: 'image-watermark' },
  { path: '/format-convert', pageKey: 'format-convert' },
  { path: '/image-compress', pageKey: 'image-compress' },
  { path: '/video-to-gif', pageKey: 'video-to-gif' },
  { path: '/video-compressor', pageKey: 'video-compressor' },
  { path: '/mp3-compressor', pageKey: 'mp3-compressor' },
  { path: '/video-to-audio', pageKey: 'video-to-audio' },
  { path: '/ai-generate', pageKey: 'ai-generate' },
  { path: '/image-search', pageKey: 'image-search' },
  { path: '/trash', pageKey: 'trash' },
  { path: '/invite', pageKey: 'invite' },
  { path: '/invite-welcome', pageKey: 'invite-welcome' },
  { path: '/invite-purchase', pageKey: 'invite-purchase' },
  { path: '/encrypted-links', pageKey: 'encrypted-links' },
  { path: '/sale-links', pageKey: 'sale-links' },
  { path: '/sale-links/:id/codes', pageKey: 'sale-codes' },
  { path: '/sale', pageKey: 'sale-buyer' },
  { path: '/sale/account', pageKey: 'sale-account' },
  { path: '/sale/:linkCode', pageKey: 'sale-buyer' },
  { path: '/share/d', pageKey: 'directory-share' },
  { path: '/share/d/:shareCode', pageKey: 'directory-share' },
  { path: '*', pageKey: null },
];

const normalizePathname = (pathname: string): string => {
  if (pathname === '/') {
    return pathname;
  }
  return pathname.replace(/\/+$/, '') || '/';
};

export const resolveImgCloudPageKey = (pathname: string): ImgCloudPageKey | null => {
  const normalizedPathname = normalizePathname(pathname);
  const route = IMG_CLOUD_ROUTE_METADATA.find(
    (metadata) =>
      metadata.pageKey !== null &&
      matchPath({ path: metadata.path, end: true }, normalizedPathname) !== null
  );
  return route?.pageKey ?? null;
};
